module.exports = __webpack_public_path__ + "static/TacarraWilliams_optionB-OPTIMIZED-8a060d0d7fe4a92f142169d0d2c97cbd.png";